import React from 'react';
import { Link } from 'react-router-dom';
const baseSellerUrl = process.env.REACT_APP_SELLER_URL || 'http://localhost:3010/';

const FooterOne = () => {
    const [isMobile, setIsMobile] = React.useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth <= 575;
    });
    const phone = '+6587333600';

    const messageLinks = [
        {
            text: 'Product Enquiry',
            msg: 'Hi, I’m interested in your product. Can you provide more details on this product? I’d like to know about the price, specifications, and availability. Thanks!'
        },
        {
            text: 'Related Order',
            msg: 'Hello, I just placed an order with you. Can you please provide an update on the status or confirm when it will be shipped? Thanks!'
        },
        {
            text: 'Related Payment',
            msg: 'Hi, I recently made a payment for my order. I just wanted to confirm if the payment went through successfully. Can you check? Thanks!'
        },
        {
            text: 'Shipping & Delivery',
            msg: 'Hi, I’d like to inquire about the shipping status of my order. Can you provide the tracking details or let me know when it’s expected to arrive? Thanks!'
        },
        {
            text: 'Return & Refund Order',
            msg: 'Hello, I’d like to return or request a refund for my order. Could you guide me through the process? Thank you!'
        }
    ];

    function getLocaleFromSubdomain() {
        const host = window.location.hostname;
        const searchTerm = 'localhost';
        // const checklocalhost = host.filter(item =>
        //     item.toLowerCase() == (searchTerm.toLowerCase())
        // );

        if (host == 'localhost') {
            return '';
        } else {
            const checklocalization = host.split('.');
            if (checklocalization.length < 3) {
                return '';
            } else {
                return `https://seller.${checklocalization[0]}.iwant-asia.com/`;
            }
        }
        // const parts = host.split(".");

        // // localhost or IP
        // if (parts.length < 3) return null;

        // return parts[0];
    }

    let sellerCommunityUrl = '';
    const userstatus = JSON.parse(localStorage.getItem('user'));
    if (localStorage.getItem('serviceToken') && userstatus.isSeller) {
        // sellerCommunityUrl="/admin/products";
        // SG
        // sellerCommunityUrl=`https://seller.sg.iwant-asia.com/login?auth=${localStorage.getItem("serviceToken")}`;
        // ID
        sellerCommunityUrl = `${baseSellerUrl}login?auth=${localStorage.getItem('serviceToken')}`;
    } else {
        sellerCommunityUrl = '/admin/login';
    }

    const locale = getLocaleFromSubdomain() ?? 'en';

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 575);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <footer className="footer py-120">
            <div className="container container-md">
                <div className="footer-item-wrapper d-flex flex-column flex-md-row ms-auto me-0  align-items-start flex-wrap">
                    <div className="footer-item" style={isMobile ? { flex: '0 0 45%', maxWidth: '45%' } : {}}>
                        <div className="footer-item__logo">
                            <Link to="/">
                                {' '}
                                {/* <img src="/assets/images/logo/logo-pink-peony.png" alt="" /> */}
                                <img src="/assets/images/logo/logo-iWant-Asia.png" alt="" />
                            </Link>
                        </div>
                    </div>
                    <div className="d-flex" style={isMobile ? { width: '100%' } : {flexGrow: 1 }}>
                        <div className="footer-item" style={isMobile ? { flex: '0 0 50%', maxWidth: '50%' } : { paddingRight: '40px' }}>
                            <div className="mb-14 text-gray-600">Support:</div>
                            <ul className="footer-menu">
                                <li className="mb-16">
                                    <Link
                                        to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent('Support assitance needed :')}`}
                                        className="text-gray-600 hover-text-main-one-600"
                                    >
                                        Help Center
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent('Hi i query for live chat :')}`}
                                        className="text-gray-600 hover-text-main-one-600"
                                    >
                                        Live Chat
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        to="/term-and-condition"
                                        className="text-gray-600 hover-text-main-one-600"
                                    >
                                        Terms and Condition
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        to="/payment-policy"
                                        className="text-gray-600 hover-text-main-one-600"
                                    >
                                        Privacy Policy
                                    </Link>
                                </li>
                                {/* <li className="mb-16">
                                <Link to="/" className="text-gray-600 hover-text-main-one-600">
                                    Check Seller Status
                                </Link>
                            </li>
                             <li className="mb-16">
                                <Link to="/" className="text-gray-600 hover-text-main-one-600">
                                    Report Abuse
                                </Link>
                            </li> */}
                                {/* <li className="mb-16">
                                <Link to="/cart" className="text-gray-600 hover-text-main-one-600">
                                    Shoping Cart
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/" className="text-gray-600 hover-text-main-one-600">
                                    Home
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/products" className="text-gray-600 hover-text-main-one-600">
                                    Products
                                </Link>
                            </li> */}
                                {/* <li className="mb-16">
                                <Link to="#" className="text-gray-600 hover-text-main-one-600">
                                    Track Shipment
                                </Link>
                            </li> */}
                                {/* <li className="mb-16">
                                <Link to="/contact" className="text-gray-600 hover-text-main-one-600">
                                    Contact Us
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/become-seller" className="text-gray-600 hover-text-main-one-600">
                                    Become a Seller
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/free-delivery" className="text-gray-600 hover-text-main-one-600">
                                    Free Delivery
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/account" className="text-gray-600 hover-text-main-one-600">
                                    My Account
                                </Link>
                            </li> */}
                            </ul>
                        </div>
                        <div className="footer-item" style={isMobile ? { flex: '0 0 50%', maxWidth: '50%' } : {}}>
                            <div className="mb-14 text-gray-600">Sell on iWant:</div>
                            <ul className="footer-menu">
                                {/* <li className="mb-16">
                                <Link to={getLocaleFromSubdomain()} className="text-gray-600 hover-text-main-one-600">
                                    Membership Programs
                                </Link>
                            </li> */}
                                <li className="mb-16">
                                    <Link to={sellerCommunityUrl} className="text-gray-600 hover-text-main-one-600">
                                        Start Selling
                                    </Link>
                                </li>
                                {/* <li className="mb-16">
                                <Link to="/" className="text-gray-600 hover-text-main-one-600">
                                    Verified Seller
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/" className="text-gray-600 hover-text-main-one-600">
                                    Partnership
                                </Link>
                            </li> */}
                                {/* <li className="mb-16">
                                <Link to="/cart" className="text-gray-600 hover-text-main-one-600">
                                    My Account
                                </Link>
                            </li>
                            <li className="mb-16">
                                <Link to="/" className="text-gray-600 hover-text-main-one-600">
                                    Order History
                                </Link>
                            </li>
                             <li className="mb-16">
                                <Link to="/cart" className="text-gray-600 hover-text-main-one-600">
                                    Shoping Cart
                                </Link>
                            </li>
                           
                            <li className="mb-16">
                                <Link to="/account" className="text-gray-600 hover-text-main-one-600">
                                    Customer Service
                                </Link>
                            </li> */}
                            </ul>
                        </div>
                    </div>

                    <div
                        className="footer-item"
                        style={
                            isMobile ? { width: '60%', flex: '0 0 100%', maxWidth: '100%', marginTop: '18px', textAlign: 'center', paddingLeft: '10px', paddingRight: '10px' } : {}
                        }
                    >
                        <h6 className="text-main-one-600" style={isMobile ? { textAlign: 'center', marginBottom: '12px' } : {}}>
                            Get In Touch With Us
                        </h6>
                        <button
                            type="button"
                            className="chat_WA position-relative w-100 h-44 position-relative  d-flex text-white align-items-center justify-content-center mb-20"
                            data-bs-toggle="modal"
                            data-bs-target="#waModal"
                        >
                            <div className="WAicon position-absolute w-44 h-44 rounded-circle border-1">
                                <i className="ph ph-whatsapp-logo"></i>
                            </div>
                            Chat via Whatsapp
                            {/* <img src={`/assets/images/social/wa.png`} alt="" className='w-100 h-100 object-fit-contain' /> */}
                        </button>
                        <div
                            className="d-flex justify-content-between align-items-center"
                            style={isMobile ? { justifyContent: 'center', gap: '12px' } : {}}
                        >
                            <Link
                                to="/https://www.instagram.com"
                                className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                            >
                                <img src={`/assets/images/social/ig.png`} alt="" className="w-100 h-100 object-fit-contain" />
                            </Link>

                            <Link
                                to="/https://www.facebook.com"
                                className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                            >
                                <img src={`/assets/images/social/fb.png`} alt="" className="w-100 h-100 object-fit-contain" />
                            </Link>

                            <Link
                                to="/https://www.tiktok.com"
                                className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                            >
                                <img src={`/assets/images/social/tiktok.png`} alt="" className="w-100 h-100 object-fit-contain" />
                            </Link>

                            <Link
                                to="/https://www.telegram.com"
                                className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                            >
                                <img src={`/assets/images/social/telegram.png`} alt="" className="w-100 h-100 object-fit-contain" />
                            </Link>
                        </div>
                        <ul className="flex-align gap-16">
                            <li>
                                {/* <Link
                                    to={`https://api.whatsapp.com/send?phone=+6587333600&text=${encodeURIComponent("Hi! I'm interested in your product.")}`}
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/wa.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link> */}
                            </li>
                            {/* <li>
                                <Link
                                    to="/https://www.instagram.com"
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/ig.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.facebook.com"
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/fb.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.tiktok.com"
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/tiktok.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/https://www.telegram.com"
                                    className="w-44 h-44 d-flex align-items-center justify-content-center rounded-circle"
                                >
                                    <img src={`/assets/images/social/telegram.png`} alt="" className='w-100 h-100 object-fit-contain' />
                                </Link>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Modal Pilihan */}
            <div className="modal fade" id="waModal" tabIndex={-1} aria-labelledby="waModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0 shadow">
                        <div className="modal-header bg-main-one-900 text-white">
                            <h5 className="modal-title text-white" id="waModalLabel">
                                Select an Option
                            </h5>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <div className="list-group">
                                {messageLinks.map((item, i) => (
                                    <Link
                                        key={i}
                                        to={`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(item.msg)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="list-group-item list-group-item-action"
                                    >
                                        {item.text}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default FooterOne;
